import ProviderDetails from "../ProviderDetails";
import PlanLists from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";
import { RelatedProviders } from "../RelatedProviders";

const DataPlan = () => {
  return (
    <div className="h-full w-full md:px-6 lg:px-8 xl:px-12 max-w-[1440px] mx-auto">
      <ExternalContainer>
        <div>
          <Header />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-6 items-start">
            {/* Left Column: Details & FAQs */}
            <div className="lg:col-span-3 xl:col-span-3 w-full">
              <ProviderDetails />
            </div>

            {/* Middle Column: Products / Plans list */}
            <div className="lg:col-span-6 xl:col-span-6 w-full min-w-0">
              <PlanLists productType="gift_cards" />
            </div>

            {/* Right Column: Related Providers */}
            <div className="lg:col-span-3 xl:col-span-3 w-full">
              <RelatedProviders productType="gift_cards" />
            </div>
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default DataPlan;
